<template>
  <v-app class="app">
    <template>
      <router-view></router-view>
    </template>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
.app >>> .theme--light.v-application {
  background-color: #f6f7fb;
}
</style>
